/**
 * Created by adaltojunior on 12/23/14.
 */

Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.NumberedDivIcon = function (options) {
  const NumberedDivIcon = L.Icon.extend({
    options: {
      shadowUrl: null,
      className: 'greenmileMarkerIcon',
      iconUrl: '',
      iconAnchor: [13, -2],
      color: '',
      content: '',
      statusClass: '',
      borderColor: '',
      plot: options.plot,
      testId: ''
    },

    createIcon: function () {
      const div = document.createElement('div');
      const options = this.options;
      const border = `border: 2px solid ${
        options.borderColor ?? 'transparent'
      }`;

      const location = GreenmileReduxStore.getState().router.location;

      const isOnRouteDetails =
        /^\/maps\/route\/\d+\/details(\/stop\/\d+)?$/.test(location.pathname);

      const getStatusClass = () => {
        const { kind } = options;

        if (kind === 'ARRIVAL' || kind === 'DEPARTURE') {
          return kind;
        }

        return options.statusClass;
      };

      const getMarkerHTML = () => {
        if (isOnRouteDetails) {
          return `
            <div class="markerRouteStops" data-testid="${
              options?.testId ?? ''
            }">
              <div class="spaceText ${getStatusClass()}">
                <div>
                  ${options.content ?? ''}
                </div>
              </div>
            </div>
        `;
        }

        return `
          <div class="markerRouteStops" data-testid="${options?.testId ?? ''}">
            <div class="spaceText" style="background-color: ${
              options.color
            }; ${border}">
              <div class="stop-marker-icon ${options.statusClass}">
                <span />
              </div>
              <div>
                ${options.content ?? ''}
              </div>
            </div>
          </div>
        `;
      };

      if (options.plot) {
        div.innerHTML = getMarkerHTML();
      }

      this._setIconStyles(div, 'icon');

      return div;
    }
  });

  return new NumberedDivIcon(options);
};
